import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';
import Image from '@repo/ui-components/tailwind/Image';
import CTAButton from '@repo/ui-components/tailwind/CTAButton';
import breakpoints from '@repo/ui-components/breakpoints';

function StatCard({ card }) {
  const [isHovering, setIsHovering] = useState(false);
  const isBrowser = typeof window !== 'undefined';
  const isDesktop =
    isBrowser && window.matchMedia(`(min-width: ${breakpoints.lg})`).matches;

  return (
    <Flex
      as={card.cta ? 'button' : 'div'}
      w="full"
      flexDir="column"
      align="center"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onFocus={() => setIsHovering(true)}
      onBlur={() => setIsHovering(false)}
    >
      <Image
        className="z-[1] max-h-56 w-full rounded-lg"
        ratio={null}
        sanityImage={card.backgroundImage}
        srcSetBasisWidth={750}
      />
      <Box
        bg="white"
        borderRadius="2xl"
        w="calc(100% - 1rem)"
        mt={-8}
        zIndex="2"
        py={8}
        px={6}
        boxShadow="0px 4px 56px 0px rgba(5, 37, 77, 0.15)"
      >
        <Text as="h3" textStyle="h3" mb={2}>
          {card.headline}
        </Text>
        <Text textStyle="h4_5_6" mb={4}>
          {card.copy}
        </Text>
        {isDesktop ? (
          <AnimatePresence>
            <Box
              as={motion.div}
              overflow="hidden"
              h="fit-content"
              initial={{ opacity: 0, height: 0 }}
              animate={{
                opacity: 1,
                height: isHovering ? 'fit-content' : 0,
              }}
            >
              <div className="inline-flex w-full justify-center">
                {card.cta.text && <CTAButton cta={card.cta} />}
              </div>
            </Box>
          </AnimatePresence>
        ) : (
          <Box as="section">
            <div className="inline-flex w-full justify-center">
              {card.cta.text && <CTAButton cta={card.cta} />}
            </div>
          </Box>
        )}
      </Box>
    </Flex>
  );
}

StatCard.propTypes = {
  card: PropTypes.shape({
    backgroundImage: PropTypes.shape({
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
    headline: PropTypes.string,
    copy: PropTypes.string,
    cta: PropTypes.shape({
      label: PropTypes.string,
      text: PropTypes.string,
    }),
  }).isRequired,
};

export default StatCard;
